import React from "react"
import Appbar from 'components/Appbar.js';
import { Hero } from 'components/Hero.js';
import CssBaseline from '@material-ui/core/CssBaseline';
import { faCogs } from '@fortawesome/free-solid-svg-icons'
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from "@material-ui/core";
import Container from '@material-ui/core/Container';
import Project from 'components/Project.js';
import heartbeat from 'images/heartbeat.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
}));

const works = [
  {
    number: 1,
    title: 'Coronary Heart Disease Prediction',
    info: 'Exploratory data analysis of the Framingham Heart Study dataset to detect the risk factors of coronary heart disease and prediction using a simple machine learning model.',
    image: heartbeat,
    url: '#/projects/heart_disease',
    project: true
  },
];

function Projects(props) {
  const classes = useStyles();

  const title = "Projects"
  const paragraph = "So many stuff that I want to investigate... Here, you can find some of my fun data science projects. Read the posts and find the code on my Github page!"

  return (
    <React.Fragment>
      <CssBaseline />
      <Appbar title={title} icon={faCogs} />
      <Hero title={title} paragraph={paragraph} />
      <main>
        <Container className={classes.cardGrid} maxWidth="lg">
          <Grid container spacing={4}>
            {works.map((work) => (
              <Grid item key={work.number} xs={12} sm={6} md={6} lg={4}>
                <Project title={work.title} info={work.info} url={work.url} image={work.image} project={work.project}/>
              </Grid>
            ))}
          </Grid>
        </Container>
      </main>
    </React.Fragment>
  )
}

export default Projects;
